import React, { useState } from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Card, CardContent } from '@/shared/components/molecules/Card/Card'
import { cn } from '@/shared/utils/helpers'

import { Integration } from '@core/api/entities/integration'

import IntegrationModal from './IntegrationModal'
import { getIntegrationImage } from '../utils/imageImports'

interface IntegrationCardProps {
	integration: Integration
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({ integration }) => {
	const { t } = useTranslation('common')
	const [isModalOpen, setIsModalOpen] = useState(false)

	const handleCardClick = () => {
		setIsModalOpen(true)
	}

	const handleCloseModal = () => {
		setIsModalOpen(false)
	}

	return (
		<>
			<Card
				className="flex justify-center items-center w-[156px] sm:w-[195px] sm:h-[120px] h-[100px] cursor-pointer bg-black border border-border rounded-lg overflow-hidden"
				onClick={handleCardClick}
			>
				<CardContent
					className={cn(integration.type === 'integrations' ? 'p-4' : 'p-0')}
				>
					<img
						src={getIntegrationImage(integration.icon || '')}
						alt={t(integration.name)}
						className={cn(
							'object-cover',
							integration.type === 'integrations'
								? 'w-full h-full'
								: 'w-[195px] h-[120px]'
						)}
					/>
				</CardContent>
			</Card>

			<IntegrationModal
				isOpen={isModalOpen}
				onClose={handleCloseModal}
				integration={integration}
			/>
		</>
	)
}

export default IntegrationCard
